// nav accessibility
(function () {
    const navItems = document.querySelectorAll('li.em-nav-listing');

    // Guards against the focusin handler immediately re-opening a submenu we
    // just closed via Escape, since closing programmatically moves focus back
    // to the trigger (which would otherwise be treated as "focus received,
    // open the submenu" again).
    let suppressAutoOpenFor = null;

    function getSubmenuTrigger(navItem) {
        return navItem.querySelector(':scope > a[aria-haspopup]');
    }

    function setSubmenuExpanded(navItem, isExpanded) {
        const trigger = getSubmenuTrigger(navItem);

        if (trigger) {
            trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }
    }

    function clearFocused() {
        navItems.forEach((navItem) => {
            navItem.classList.remove('focused');
            setSubmenuExpanded(navItem, false);
        });
    }

    // Escape must actually collapse the submenu (not just remove a class that
    // CSS `:focus-within` would otherwise override) and return focus to the
    // trigger, so keyboard users aren't stuck tabbing through every submenu
    // item each time they navigate the page.
    function closeSubmenuAndFocusTrigger(navItem) {
        navItem.classList.remove('focused');
        setSubmenuExpanded(navItem, false);

        const trigger = getSubmenuTrigger(navItem);
        if (trigger) {
            suppressAutoOpenFor = trigger;
            trigger.focus();
        }
    }

    function activateAllProductsPanel(item) {
        const handle = (item.getAttribute('data-handle') || '').toLowerCase();
        const megaMenu = item.closest('.em-mega-menu-dd-main');

        if (!megaMenu) {
            return;
        }

        const allProducts = megaMenu.querySelector('.bs-mega-menu-all-allpro-main');
        const seriesProducts = megaMenu.querySelector('.bs-mega-menu-all-shopbyseries-main');
        const appProducts = megaMenu.querySelector('.bs-mega-menu-all-shopbyapp-main');

        if (!allProducts || !seriesProducts || !appProducts) {
            return;
        }

        allProducts.style.display = 'none';
        seriesProducts.style.display = 'none';
        appProducts.style.display = 'none';

        if (handle === 'shop-by-series') {
            seriesProducts.style.display = 'block';
        } else if (handle === 'shop-by-application') {
            appProducts.style.display = 'block';
        } else {
            allProducts.style.display = 'block';
        }
    }

    navItems.forEach(function (item) {
        item.addEventListener('focus', function () {
            clearFocused();
            item.classList.add('focused');
            setSubmenuExpanded(item, true);
        });

        item.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                clearFocused();
                item.classList.add('focused');
                setSubmenuExpanded(item, true);

                if (event.key === ' ') {
                    event.preventDefault();
                }
            }

            if (event.key === 'Escape' && item.classList.contains('focused')) {
                event.stopPropagation();
                closeSubmenuAndFocusTrigger(item);
            }
        });
    });

    document.addEventListener('focusin', function (event) {
        const navItem = event.target.closest('li.em-nav-listing');

        if (navItem) {
            if (suppressAutoOpenFor === event.target) {
                suppressAutoOpenFor = null;
                clearFocused();
                return;
            }

            clearFocused();
            navItem.classList.add('focused');
            setSubmenuExpanded(navItem, true);
            return;
        }

        if (!event.target.closest('.em-mega-menu-dd-main')) {
            clearFocused();
        }
    });

    document.querySelectorAll('.bs-all-pro-hoverworking').forEach(function (item) {
        // Skip hover/focus panel-switching for category header items (Shop By Series / Shop By Application)
        if (item.querySelector('a.shop-by-category')) {
            return;
        }

        item.addEventListener('mouseenter', function () {
            const parentList = item.closest('.childlist');
            if (parentList) {
                parentList.querySelectorAll('.bs-all-pro-hoverworking').forEach((node) => node.classList.remove('bs-all-pro-active'));
            }
            item.classList.add('bs-all-pro-active');
            activateAllProductsPanel(item);
        });

        item.addEventListener('focusin', function () {
            const parentList = item.closest('.childlist');
            if (parentList) {
                parentList.querySelectorAll('.bs-all-pro-hoverworking').forEach((node) => node.classList.remove('bs-all-pro-active'));
            }
            item.classList.add('bs-all-pro-active');
            activateAllProductsPanel(item);
        });
    });
})();

// product card image dedupe for assistive tech
(function () {
    const managedAttr = 'data-a11y-managed-duplicate-image';
    const cardImageContainerSelector = [
        '.product-card .product-card__image-wrapper',
        '.product-card .grid-view-item__image-wrapper',
        '.grid-view-item.product-card .grid-view-item__image-wrapper',
        '.list-view-item .list-view-item__image-wrapper'
    ].join(',');

    function hideDuplicateImageFromAT(imageElement) {
        imageElement.setAttribute('alt', '');
        imageElement.setAttribute('aria-hidden', 'true');
        imageElement.setAttribute('role', 'presentation');
        imageElement.setAttribute(managedAttr, 'true');
    }

    function keepPrimaryImageForAT(imageElement) {
        imageElement.removeAttribute('aria-hidden');
        if (imageElement.getAttribute('role') === 'presentation') {
            imageElement.removeAttribute('role');
        }
        imageElement.removeAttribute(managedAttr);
    }

    function syncProductCardImageAccessibility() {
        document.querySelectorAll(cardImageContainerSelector).forEach(function (imageContainer) {
            const images = imageContainer.querySelectorAll('img');

            if (!images.length) {
                return;
            }

            keepPrimaryImageForAT(images[0]);

            if (!images[0].hasAttribute('alt')) {
                images[0].setAttribute('alt', '');
            }

            for (let index = 1; index < images.length; index += 1) {
                hideDuplicateImageFromAT(images[index]);
            }
        });
    }

    function initializeProductCardImageGuard() {
        syncProductCardImageAccessibility();

        const observer = new MutationObserver(function (mutations) {
            const shouldResync = mutations.some(function (mutation) {
                return mutation.type === 'childList' || mutation.attributeName === 'src' || mutation.attributeName === 'data-src';
            });

            if (shouldResync) {
                syncProductCardImageAccessibility();
            }
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['src', 'data-src']
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeProductCardImageGuard);
    } else {
        initializeProductCardImageGuard();
    }
})();

// aria-hidden focus management
(function () {
    const managedAttr = 'data-a11y-hidden-focus';
    const previousTabindexAttr = 'data-a11y-previous-tabindex';
    const noPreviousTabindexValue = '__none__';
    const focusableSelector = [
        'a[href]',
        'area[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'summary',
        'iframe',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex^="-"])'
    ].join(',');

    function isInAriaHiddenSubtree(element) {
        return Boolean(element.closest('[aria-hidden="true"]'));
    }

    function makeUntabbable(element) {
        if (element.getAttribute(managedAttr) === 'true') {
            return;
        }

        const previousTabindex = element.getAttribute('tabindex');
        element.setAttribute(previousTabindexAttr, previousTabindex === null ? noPreviousTabindexValue : previousTabindex);
        element.setAttribute('tabindex', '-1');
        element.setAttribute(managedAttr, 'true');
    }

    function restoreTabbableState(element) {
        if (element.getAttribute(managedAttr) !== 'true') {
            return;
        }

        const previousTabindex = element.getAttribute(previousTabindexAttr);

        if (previousTabindex === noPreviousTabindexValue || previousTabindex === null) {
            element.removeAttribute('tabindex');
        } else {
            element.setAttribute('tabindex', previousTabindex);
        }

        element.removeAttribute(previousTabindexAttr);
        element.removeAttribute(managedAttr);
    }

    function syncAriaHiddenFocusability() {
        document.querySelectorAll('[aria-hidden="true"]').forEach(function (hiddenRoot) {
            if (hiddenRoot.matches(focusableSelector) || hiddenRoot.hasAttribute('tabindex')) {
                makeUntabbable(hiddenRoot);
            }

            hiddenRoot.querySelectorAll(focusableSelector).forEach(function (focusableElement) {
                makeUntabbable(focusableElement);
            });
        });

        document.querySelectorAll('[' + managedAttr + '="true"]').forEach(function (managedElement) {
            if (!isInAriaHiddenSubtree(managedElement)) {
                restoreTabbableState(managedElement);
            }
        });
    }

    function initializeAriaHiddenFocusGuard() {
        syncAriaHiddenFocusability();

        const observer = new MutationObserver(function (mutations) {
            const shouldResync = mutations.some(function (mutation) {
                return mutation.type === 'childList' || mutation.attributeName === 'aria-hidden' || mutation.attributeName === 'tabindex';
            });

            if (shouldResync) {
                syncAriaHiddenFocusability();
            }
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['aria-hidden', 'tabindex']
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeAriaHiddenFocusGuard);
    } else {
        initializeAriaHiddenFocusGuard();
    }
})();

// combobox popup role normalization (Boost Search runtime markup)
(function () {
    const validPopupRoles = ['listbox', 'grid', 'tree', 'dialog'];
    const boostInputSelector = 'input[role="combobox"][aria-owns^="boost-sd__search-widget-init-wrapper"]';

    function getSafePopupRole(popupElement) {
        const rawRole = (popupElement.getAttribute('role') || '').trim();
        if (validPopupRoles.indexOf(rawRole) !== -1) {
            return rawRole;
        }
        return 'listbox';
    }

    function normalizeBoostCombobox(inputElement) {
        const popupId = inputElement.getAttribute('aria-owns');
        if (!popupId) {
            return;
        }

        const popupElement = document.getElementById(popupId);
        if (!popupElement) {
            return;
        }

        const popupRole = getSafePopupRole(popupElement);

        if (popupElement.getAttribute('role') !== popupRole) {
            popupElement.setAttribute('role', popupRole);
        }

        if (inputElement.getAttribute('aria-haspopup') !== popupRole) {
            inputElement.setAttribute('aria-haspopup', popupRole);
        }

        if (inputElement.getAttribute('aria-controls') !== popupId) {
            inputElement.setAttribute('aria-controls', popupId);
        }
    }

    function syncBoostComboboxPopupRoles() {
        document.querySelectorAll(boostInputSelector).forEach(function (inputElement) {
            normalizeBoostCombobox(inputElement);
        });
    }

    function initializeBoostComboboxRoleGuard() {
        syncBoostComboboxPopupRoles();

        const observer = new MutationObserver(function () {
            syncBoostComboboxPopupRoles();
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['role', 'aria-owns', 'aria-haspopup']
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeBoostComboboxRoleGuard);
    } else {
        initializeBoostComboboxRoleGuard();
    }
})();
